"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostMessageChannel = void 0;
const topic_1 = require("../../topic");
const POST_MESSAGE_CHANNEL = 'postMessage';
class PostMessageChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = POST_MESSAGE_CHANNEL;
        this.topics = {
            RegisterHandler: new topic_1.Topic('RegisterHandler', POST_MESSAGE_CHANNEL, this._logger),
        };
    }
}
exports.PostMessageChannel = PostMessageChannel;
//# sourceMappingURL=post-message.channel.js.map